import { Dispatch } from 'redux';
import authCookie from '../lib/authCookie';
import * as actionTypes from './actionTypes';

export interface SecretQuestionInfo {
    secretQuestion1: string;
    secretQuestion2: string;
    secretQuestion3: string;
    secretAnswer1: string;
    secretAnswer2: string;
    secretAnswer3: string;
}

export interface ChangePasswordInfo {
    currentPassword: string;
    newPassword: string;
    confirmPassword: string;
}

export interface ContextDetails {
    debug: boolean;
}

export function authenticateUser(
    email: string,
    password: string,
    productInstanceId: number | null,
    mfaMethod?: string,
    mfaCode?: string
) {
    return {
        type: actionTypes.AUTHENTICATE_USER,
        payload: {
            request: {
                method: 'post',
                url: 'login',
                data: {
                    email,
                    password,
                    productInstanceId,
                    mfaMethod,
                    mfaCode,
                },
            },
        },
    };
}

export function sendMfaCode(email: string, mfaMethod: string) {
    return {
        type: actionTypes.SEND_MFA_CODE,
        payload: {
            request: {
                method: 'post',
                url: 'sendmfacode',
                data: {
                    email,
                    mfaMethod,
                },
            },
        },
    };
}

export function verifyToken() {
    return {
        type: actionTypes.VERIFY_TOKEN,
        payload: {
            request: {
                method: 'get',
                url: 'token/verify',
            },
        },
    };
}

export function logoutUser() {
    return {
        type: actionTypes.LOGOUT_USER,
        payload: {
            request: {
                method: 'get',
                url: 'logout',
            },
        },
    };
}

export function exchangeToken(token: string) {
    return {
        type: actionTypes.EXCHANGE_TOKEN,
        payload: {
            request: {
                method: 'post',
                url: `sso/callback/${token}`,
            },
        },
    };
}

export function saveFirstLoginChanges(
    secretQuestionInfo: SecretQuestionInfo,
    changePasswordInfo: ChangePasswordInfo
) {
    return {
        type: actionTypes.FIRST_LOGIN_SAVE,
        payload: {
            request: {
                method: 'post',
                url: 'user/savefirstloginchanges',
                data: {
                    userProfileDetails: {
                        secretQuestion1: secretQuestionInfo.secretQuestion1,
                        secretQuestion2: secretQuestionInfo.secretQuestion2,
                        secretQuestion3: secretQuestionInfo.secretQuestion3,
                        secretAnswer1: secretQuestionInfo.secretAnswer1,
                        secretAnswer2: secretQuestionInfo.secretAnswer2,
                        secretAnswer3: secretQuestionInfo.secretAnswer3,
                    },
                    UserChangePasswordDetails: {
                        currentPassword: changePasswordInfo.currentPassword,
                        newPassword: changePasswordInfo.newPassword,
                        confirmPassword: changePasswordInfo.confirmPassword,
                    },
                },
            },
        },
    };
}

export const setAuthToken = (auth: any) => {
    authCookie.set(auth);
    return {
        type: actionTypes.SET_AUTH_TOKEN,
        payload: auth,
    };
};

export const clearAuthToken = () => {
    authCookie.clear();
    return {
        type: actionTypes.CLEAR_AUTH_TOKEN,
        payload: authCookie.get(),
    };
};

export function setGRDebugContext(contextDetails: ContextDetails) {
    const contextCriteria = {
        debug: contextDetails.debug,
    };

    return function (dispatch: Dispatch) {
        dispatch(setGRDebugContextAction(contextCriteria));
        return Promise.resolve();
    };
}

function setGRDebugContextAction(contextCriteria: { debug: boolean }) {
    return {
        type: actionTypes.SET_GUIDED_RESPONSE_DEBUG_CONTEXT,
        contextCriteria: contextCriteria,
    };
}

export const keepSessionAlive = () => {
    return {
        type: actionTypes.KEEP_SESSION_ALIVE,
        payload: {
            request: {
                method: 'get',
                url: 'token/keepSessionAlive',
            },
        },
    };
};
